<div class="loaderwrapper" *ngIf="loader" style="z-index: 1024;">
    <span class="loader"></span>
</div>
<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="row mb-3">
            <div class="col-12">
                <div class="pg-header align-items-center">
                    <div class="pg-header__crumbs">
                        <h1 class="pg-title pg-title--with-back">
                            <button type="button" class="pg-back" (click)="showPlantList()" title="Back to Plant Profile"
                                aria-label="Back to Plant Profile">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M15.5 12H9.5" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.5 15L8.5 12L11.5 9" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                            <span class="profile-title">
                                {{ selectedPlantName }}
                                <span class="profile-title__address" *ngIf="plantDetail?.address">
                                    <i class="ri-map-pin-2-line" aria-hidden="true"></i>{{ plantDetail.address }}
                                </span>
                            </span>
                        </h1>
                    </div>
                    <div class="pg-header__actions">
                        <span *ngIf="plantDetail?.updatedAT" class="text-muted" style="font-size: 13px;">
                            Plant updated at: {{ plantDetail.updatedAT | date : 'short' }}
                        </span>
                        <button class="btn btn-dark btn-circle refresh p-1" aria-label="Refresh"
                            [@rotateAnimation]="isReloadingBtn ? 'reloading' : 'default'"
                            (click)="reloadPlantDetails()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 12 12"
                                fill="none" style="color:currentColor">
                                <path
                                    d="M2.01001 8.51007C2.19001 8.81007 2.41 9.09009 2.66 9.34009C4.5 11.1801 7.49 11.1801 9.34 9.34009C10.09 8.59009 10.52 7.64004 10.66 6.67004"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M1.33997 5.33007C1.47997 4.35007 1.90997 3.41003 2.65997 2.66003C4.49997 0.820029 7.48997 0.820029 9.33997 2.66003C9.59997 2.92003 9.80996 3.20005 9.98996 3.49005"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M1.81995 11.1801V8.51007H4.48993" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10.18 0.820068V3.49005H7.51001" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Plant summary -->
        <div class="profile-stats mb-3">
            <app-stat-card icon="assets/img/icons/ic_battery.svg" label="Installed Capacity"
                [value]="plantDetail?.capacity" unit="kW"></app-stat-card>
            <app-stat-card icon="assets/img/icons/ic_sun.svg" label="Daily Expected Generation"
                [value]="plantDetail?.todayGeneration"></app-stat-card>
            <app-stat-card iconClass="ri-money-dollar-circle-line" label="Installation Cost"
                [value]="plantDetail?.costFormatted"></app-stat-card>
            <app-stat-card iconClass="ri-map-pin-2-line" label="Region, City &amp; Status" [custom]="true">
                <span class="badge badge-custom badge-success d-inline-flex" *ngIf="plantDetail?.region_name">
                    {{ plantDetail?.region_name }}
                </span>
                <span class="badge badge-custom badge-warning d-inline-flex" *ngIf="plantDetail?.city_region_name">
                    {{ plantDetail?.city_region_name }}
                </span>
                <span class="badge badge-custom badge-danger d-inline-flex" *ngIf="plantDetail?.contract_type_name">
                    {{ plantDetail?.contract_type_name }}
                </span>
                <span class="text-muted"
                    *ngIf="!plantDetail?.region_name && !plantDetail?.city_region_name && !plantDetail?.contract_type_name">
                    No details available
                </span>
            </app-stat-card>
        </div>

        <!-- Tabs -->
        <nav class="profile-tabs mb-3" aria-label="Plant sections">
            <a *ngFor="let tab of tabs" class="profile-tabs__item" [routerLink]="tabLink(tab.key)"
                [class.is-active]="activeTab === tab.key" [attr.aria-current]="activeTab === tab.key ? 'page' : null">
                {{ tab.label }}
            </a>
        </nav>

        <!-- Devices -->
        <ng-container *ngIf="activeTab === 'devices'">
            <div class="profile-card profile-devices">
                <app-plant-devices [reloadDevices]="isReloadingBtn">
                    <div devicesSummary class="profile-chips" *ngIf="heatMapList">
                        <span class="profile-chip profile-chip--success">{{ heatMapList.Connected }} Connected</span>
                        <span class="profile-chip profile-chip--danger">{{ heatMapList.Disconnected }} Disconnected</span>
                        <span class="profile-chip profile-chip--muted">{{ heatMapList.Faulty }} Faulty</span>
                    </div>
                </app-plant-devices>
            </div>
        </ng-container>

        <!-- ROI -->
        <!-- Coming soon until ROI is ready; restore the block below then. -->
        <app-comming-soon *ngIf="activeTab === 'roi'" heading="ROI is coming soon"
            message="Payback graphs, savings and prediction parameters for this plant will be available here shortly."></app-comming-soon>
        <!--
        <ng-container *ngIf="activeTab === 'roi'">
            <div class="profile-stats mb-3">
                <app-stat-card iconClass="ri-money-dollar-circle-line" label="Installation Cost"
                    [value]="installationCost || plantDetail?.costFormatted"></app-stat-card>
                <app-stat-card iconClass="ri-wallet-3-line" label="Total Savings" valueClass="is-positive"
                    [value]="plantDetail?.lifeTimeSaving"></app-stat-card>
                <app-stat-card iconClass="ri-calendar-line" label="Monthly Savings"
                    [value]="plantDetail?.monthlySavings"></app-stat-card>
                <app-stat-card iconClass="ri-flag-2-line" label="Breakeven Year"
                    [value]="breakEvenYear" [unit]="breakEvenYear ? '(approx.)' : null"></app-stat-card>
            </div>

            <div class="profile-split">
                <section class="profile-card profile-split__main roi-tab">
                    <div class="profile-card__head">
                        <div>
                            <h2 class="profile-card__title">Payback</h2>
                            <span class="profile-card__sub">{{ yearlyRoi ? 'Yearly' : 'Monthly' }} payback {{ yearRangeTitle }}</span>
                        </div>
                        <div class="d-flex align-items-center gap-2 flex-wrap">
                            <div class="profile-toggle" role="group" aria-label="Payback period">
                                <button type="button" [class.is-active]="yearlyRoi" [attr.aria-pressed]="yearlyRoi"
                                    (click)="getYearlyRoiGraph()">Year</button>
                                <button type="button" [class.is-active]="monthlyRoi" [attr.aria-pressed]="monthlyRoi"
                                    (click)="getMonthlyRoiGraph()">Month</button>
                            </div>
                            <button type="button" class="btn btn-outline-dark rounded" (click)="reCalculateRoi()">
                                Re-Calculate
                            </button>
                        </div>
                    </div>
                    <div *ngIf="roiChart && seriesData && seriesData.length > 0; else noDataMessage">
                        <apx-chart [series]="roiChart.series" [chart]="roiChart.chart" [colors]="roiChart.colors"
                            [stroke]="roiChart.stroke" [fill]="roiChart.fill" [markers]="roiChart.markers"
                            [dataLabels]="roiChart.dataLabels" [legend]="roiChart.legend" [grid]="roiChart.grid"
                            [xaxis]="roiChart.xaxis" [yaxis]="roiChart.yaxis" [tooltip]="roiChart.tooltip"
                            [annotations]="roiChart.annotations" [isDisabled]="true">
                            <!~~ [isDisabled] is for ngx-bootstrap's [tooltip] directive, which also
                                 matches this element and would show "[object Object]". ~~>
                        </apx-chart>
                    </div>
                    <ng-template #noDataMessage>
                        <div class="profile-empty">{{ responseMessage }}</div>
                    </ng-template>
                </section>

                <section class="profile-card profile-split__side">
                    <div class="profile-card__head">
                        <h2 class="profile-card__title">Cost &amp; Parameters</h2>
                    </div>
                    <dl class="profile-list">
                        <div><dt>Today's Savings</dt><dd>{{ plantDetail?.todaySaving ?? '—' }}</dd></div>
                        <div><dt>Total Generation</dt><dd>{{ plantDetail?.lifeTimeEnergy ?? '—' }}</dd></div>
                        <div><dt>Tariff Rate</dt><dd>{{ roiParameters?.['tariff_rate'] ?? '—' }}</dd></div>
                        <div><dt>Decline / Year</dt><dd>{{ roiParameters?.['dip_percentage'] != null ? roiParameters['dip_percentage'] + '%' : '—' }}</dd></div>
                        <div><dt>Est. Production (Year 1)</dt><dd>{{ roiParameters?.['base'] != null ? (roiParameters['base'] | number : '1.0-0') : '—' }}</dd></div>
                        <div><dt>Est. Production (Year 2)</dt><dd>{{ roiParameters?.['next_year_production'] != null ? (roiParameters['next_year_production'] | number : '1.0-0') : '—' }}</dd></div>
                    </dl>
                    <div class="profile-actions" *ngIf="permissionsReady && permissions.canEdit && plantDetail">
                        <button type="button" class="btn btn-dark rounded" (click)="openUpdateCostModal(costUpdate)">
                            Update Cost
                        </button>
                        <button type="button" class="btn btn-outline-dark rounded"
                            (click)="openPredictionModal(calculatePredictionParameter)">
                            Prediction Parameters
                        </button>
                    </div>
                </section>
            </div>
        </ng-container>
        -->

        <!-- Panels -->
        <!-- Coming soon until Panels is ready; restore the block below then. -->
        <app-comming-soon *ngIf="activeTab === 'panels'" heading="Panels are coming soon"
            message="Panel inventory, inverter heat map and panel actions for this plant will be available here shortly."></app-comming-soon>
        <!--
        <ng-container *ngIf="activeTab === 'panels'">
            <div class="profile-stats mb-3">
                <app-stat-card icon="assets/img/icons/ic_sola-plate.svg" label="Total Panels"
                    [value]="totalPanels"></app-stat-card>
                <app-stat-card icon="assets/img/icons/ic_thunder.svg" label="No. of Inverters"
                    [value]="inverters.length"></app-stat-card>
                <app-stat-card iconClass="ri-links-line" label="Strings" [value]="pvStrings.length"></app-stat-card>
            </div>

            <div class="profile-split">
                <section class="profile-card profile-split__side profile-split__side--first">
                    <div class="profile-card__head">
                        <div>
                            <h2 class="profile-card__title">Inverter Heat Map</h2>
                            <span class="profile-card__sub">Select an inverter to see its panels.</span>
                        </div>
                    </div>
                    <div class="heat-counts" *ngIf="heatMapList">
                        <div><span class="text-success">Connected</span><b>{{ heatMapList.Connected }}</b></div>
                        <div><span class="text-danger">Disconnected</span><b>{{ heatMapList.Disconnected }}</b></div>
                        <div><span class="text-muted">Faulty</span><b>{{ heatMapList.Faulty }}</b></div>
                    </div>
                    <div class="heat-grid">
                        <button type="button" class="heat-cell" *ngFor="let cell of heatMapList?.data"
                            [style.background]="getHeatColor(cell?.color)"
                            [class.is-selected]="isSelectedInverter(cell?.devName)"
                            [attr.aria-label]="cell?.devName" [title]="cell?.devName"
                            (click)="selectInverterByName(cell?.devName)"></button>
                    </div>
                </section>

                <section class="profile-card profile-split__main p-0">
                    <div class="profile-card__head profile-card__head--bordered panels-head">
                        <div>
                            <h2 class="profile-card__title">Panels</h2>
                            <span class="profile-card__sub">{{ selectedInverterName || 'All inverters' }}</span>
                        </div>
                        <button type="button" class="btn btn-dark rounded panels-add"
                                *ngIf="permissionsReady && permissions.canAdd" [disabled]="!selectedPvId"
                                [title]="!selectedPvId ? 'Select an inverter and string first' : ''"
                                (click)="addPanel(addPanelModal)">
                                + Add Panel
                            </button>
                    </div>

                    <div class="panels-filters">
                            <ng-select class="sb-filter-field panels-inverter"
                                placeholder="All Inverters" aria-label="Select inverter" [items]="inverters"
                                bindLabel="name" bindValue="devId" [clearable]="true"
                                [loading]="invertersLoading" loadingText="Loading inverters..."
                                [ngModel]="selectedInverterId" (ngModelChange)="onInverterChange($event)">
                            </ng-select>
                            <ng-select class="sb-filter-field panels-inverter" placeholder="All strings"
                                aria-label="Select string" [items]="pvStrings" bindLabel="label" bindValue="id"
                                [loading]="pvStringsLoading" loadingText="Loading strings..."
                                [disabled]="!selectedInverterId" [ngModel]="selectedPvId"
                                (ngModelChange)="onPvChange($event)">
                                <ng-template ng-option-tmp let-item="item">
                                    {{ item.label }} ({{ item.panel_count }} panel{{ item.panel_count === 1 ? '' : 's' }})
                                </ng-template>
                            </ng-select>
                            <ng-select class="sb-filter-field panels-inverter" placeholder="Status"
                                aria-label="Filter by status" [items]="statusOptions" bindLabel="label"
                                bindValue="value" [clearable]="false" [ngModel]="statusFilter"
                                (ngModelChange)="onStatusFilterChange($event)">
                            </ng-select>
                            <div class="btn-group input-wrapper sb-filter-search-group" role="group">
                                <input type="text" class="sb-filter-field sb-filter-search-input"
                                    placeholder="Search Sr No / Series" (input)="searchPanels($event)">
                                <button type="button" class="btn sb-filter-search-btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                        fill="none">
                                        <path
                                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </div>
                    </div>

                    <div class="table-toolbar px-3 py-2" *ngIf="selectedPanelIds.length">
                        <span class="fw-semibold">{{ selectedPanelIds.length }} selected</span>
                        <div class="d-flex gap-2">
                            <button type="button" class="btn btn-outline-dark btn-sm"
                                (click)="openBulkAction('transfer', bulkActionModal)">Bulk Transfer</button>
                            <button type="button" class="btn btn-outline-dark btn-sm"
                                (click)="openBulkAction('dispose', bulkActionModal)">Bulk Dispose</button>
                            <button type="button" class="btn btn-outline-dark btn-sm"
                                (click)="openBulkAction('sale', bulkActionModal)">Bulk Sell</button>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table panels-table mb-0">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 36px;">
                                        <label class="custom-checkbox large">
                                            <input type="checkbox" [checked]="allPanelsSelected"
                                                (change)="toggleAllPanels($event.target.checked)" />
                                            <span class="checkbox-item"></span>
                                        </label>
                                    </th>
                                    <th scope="col">Sr No</th>
                                    <th scope="col">Brand</th>
                                    <th scope="col">Series Name</th>
                                    <th scope="col">Capacity (kW)</th>
                                    <th scope="col">Location</th>
                                    <th scope="col">Status</th>
                                    <th scope="col" class="text-end">Actions</th>
                                </tr>
                            </thead>
                            <tbody [attr.aria-busy]="panelsLoading">
                                <!~~ Loading: placeholder rows shaped like the real ones ~~>
                                <ng-container *ngIf="panelsLoading">
                                    <tr *ngFor="let row of skeletonRows" class="placeholder-glow" aria-hidden="true">
                                        <td><span class="placeholder rounded panels-ph panels-ph--box"></span></td>
                                        <td><span class="placeholder rounded panels-ph col-8"></span></td>
                                        <td><span class="placeholder rounded panels-ph col-7"></span></td>
                                        <td><span class="placeholder rounded panels-ph col-9"></span></td>
                                        <td><span class="placeholder rounded panels-ph col-5"></span></td>
                                        <td><span class="placeholder rounded panels-ph col-10"></span></td>
                                        <td><span class="placeholder panels-ph panels-ph--pill"></span></td>
                                        <td class="text-end"><span class="placeholder panels-ph panels-ph--dot"></span></td>
                                    </tr>
                                </ng-container>
                                <tr *ngFor="let panel of (panelsLoading ? [] : panels)" [class.panel-row--disconnected]="panel.device_connected === false">
                                    <td>
                                        <label class="custom-checkbox large">
                                            <input type="checkbox" [checked]="selectedPanelIds.includes(panel.id)"
                                                (change)="togglePanelSelection(panel)" />
                                            <span class="checkbox-item"></span>
                                        </label>
                                    </td>
                                    <td class="fw-semibold">{{ panel.sr_no }}</td>
                                    <td>{{ panel.brand_detail?.name }}</td>
                                    <td>{{ panel.series_name }}</td>
                                    <td>{{ panel.capacity_kw }}</td>
                                    <td>{{ panelLocationLabel(panel) }}</td>
                                    <td>
                                        <span class="badge badge-custom badge-sm" [ngClass]="getPanelStatusBadgeClass(panel.status)">
                                            {{ panel.status_display }}
                                        </span>
                                        <span class="badge badge-custom badge-sm badge-danger ms-1"
                                            *ngIf="panel.device_connected === false" title="Device disconnected">
                                            Disconnected
                                        </span>
                                    </td>
                                    <td class="text-end">
                                        <!~~ container="body": the menu would otherwise be clipped by
                                             the table's scroll box (same as the Plants list). ~~>
                                        <div ngbDropdown container="body" placement="bottom-end auto"
                                            class="d-inline-block">
                                            <button type="button" class="action-btn" ngbDropdownToggle
                                                [attr.aria-label]="'Actions for ' + panel.sr_no">
                                                <svg width="4" height="16" viewBox="0 0 4 16" fill="currentColor"
                                                    aria-hidden="true">
                                                    <circle cx="2" cy="2" r="1.75" />
                                                    <circle cx="2" cy="8" r="1.75" />
                                                    <circle cx="2" cy="14" r="1.75" />
                                                </svg>
                                            </button>
                                            <div ngbDropdownMenu>
                                                <button ngbDropdownItem (click)="viewPanelHistory(panel, panelHistoryModal)">History</button>
                                                <button ngbDropdownItem *ngIf="isPanelActionAvailable(panel, 'transfer') && panel.device_connected !== false"
                                                    (click)="selectedPanelIds = [panel.id]; openBulkAction('transfer', bulkActionModal)">Transfer</button>
                                                <button ngbDropdownItem *ngIf="isPanelActionAvailable(panel, 'dispose') && panel.device_connected !== false"
                                                    (click)="selectedPanelIds = [panel.id]; openBulkAction('dispose', bulkActionModal)">Dispose</button>
                                                <button ngbDropdownItem *ngIf="isPanelActionAvailable(panel, 'sale') && panel.device_connected !== false"
                                                    (click)="selectedPanelIds = [panel.id]; openBulkAction('sale', bulkActionModal)">Sell</button>
                                                <button ngbDropdownItem *ngIf="isPanelActionAvailable(panel, 'approve')"
                                                    (click)="approvePanelRequest(panel)">Approve</button>
                                                <button ngbDropdownItem *ngIf="canReject(panel)"
                                                    (click)="rejectPanelRequest(panel)">Reject</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngIf="!panelsLoading && !panels.length">
                                    <td colspan="8" class="text-center text-muted py-4">
                                        No panels found for the current filters.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-meta px-3" *ngIf="!panelsLoading && panels.length > 0">
                        <div class="entries">
                            <span>Total Records: {{ totalRecords }}</span>
                        </div>
                        <nav class="table-pagination">
                            <ul>
                                <li><a class="init-bg" (click)="goToPage(1)" [class.disabled]="currentPage === 1">1</a></li>
                                <li><a class="no-bg" (click)="navigatePage('prev')" [class.disabled]="currentPage === 1"><i class="fa fa-chevron-left"></i></a></li>
                                <li><a class="active">{{ currentPage }}</a></li>
                                <li><a class="no-bg" (click)="navigatePage('next')" [class.disabled]="currentPage === totalPages"><i class="fa fa-chevron-right"></i></a></li>
                                <li><a class="init-bg" (click)="goToPage(totalPages)" [class.disabled]="currentPage === totalPages">{{ totalPages }}</a></li>
                            </ul>
                        </nav>
                    </div>
                </section>
            </div>
        </ng-container>
        -->
    </div>
</section>

<ng-template #addPanelModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Add Panels — {{ selectedInverterName }} / {{ selectedPvLabel }}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cancel click')"></button>
    </div>
    <div class="modal-body">
        <div class="row g-2 mb-2 fw-semibold" *ngIf="addPanelRows.length">
            <div class="col-3">Sr No</div>
            <div class="col-3">Brand</div>
            <div class="col-3">Series Name</div>
            <div class="col-2">Capacity (kW)</div>
        </div>
        <div class="row g-2 mb-2 align-items-center" *ngFor="let row of addPanelRows; let i = index">
            <div class="col-3"><input type="text" class="form-control" [(ngModel)]="row.sr_no" /></div>
            <div class="col-3">
                <ng-select [items]="brands" bindLabel="name" bindValue="id" [loading]="brandsLoading"
                    [clearable]="false" [(ngModel)]="row.brand"></ng-select>
            </div>
            <div class="col-3"><input type="text" class="form-control" [(ngModel)]="row.series_name" /></div>
            <div class="col-2"><input type="number" step="0.001" class="form-control" [(ngModel)]="row.capacity_kw" /></div>
            <div class="col-1">
                <button type="button" class="panel-action panel-action--danger" (click)="removePanelRow(i)" *ngIf="addPanelRows.length > 1">&times;</button>
            </div>
        </div>
        <button type="button" class="btn btn-outline-dark btn-sm mt-2" (click)="addPanelRow()">+ Add Row</button>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" (click)="d('Cancel click')">Cancel</button>
        <button type="button" class="btn btn-orange" [disabled]="addPanelSubmitting" (click)="submitAddPanels(c)">
            {{ addPanelSubmitting ? 'Saving...' : 'Save' }}
        </button>
    </div>
</ng-template>

<ng-template #bulkActionModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title text-capitalize">Bulk {{ bulkActionType }} ({{ selectedPanelIds.length }} panel(s))</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cancel click')"></button>
    </div>
    <div class="modal-body">
        <div class="form-styles mb-3" *ngIf="bulkActionType === 'transfer'">
            <label>Destination Plant</label>
            <ng-select [items]="transferPlants" bindLabel="stationName" bindValue="stationCode" [clearable]="false"
                placeholder="Select destination plant" [ngModel]="selectedTransferPlantCode"
                (ngModelChange)="onTransferPlantChange($event)"></ng-select>
        </div>
        <div class="form-styles mb-3" *ngIf="bulkActionType === 'transfer'">
            <label>Destination Inverter</label>
            <ng-select [items]="transferInverters" bindLabel="devName" bindValue="devId" [clearable]="false"
                [disabled]="!selectedTransferPlantCode" placeholder="Select destination inverter"
                [ngModel]="selectedTransferInverterId" (ngModelChange)="onTransferInverterChange($event)"></ng-select>
        </div>
        <div class="form-styles mb-3" *ngIf="bulkActionType === 'transfer'">
            <label>Destination String</label>
            <ng-select [items]="transferPvStrings" bindLabel="label" bindValue="id" [clearable]="false"
                [disabled]="!selectedTransferInverterId" placeholder="Select destination string"
                [(ngModel)]="selectedTransferPvId"></ng-select>
        </div>
        <div class="form-styles">
            <label>Reason</label>
            <textarea class="form-control" rows="3" [(ngModel)]="bulkActionReason"
                placeholder="Optional reason for this request"></textarea>
        </div>
    </div>
    <div class="modal-footer no-bg">
        <button type="button" class="btn btn-outline-dark" (click)="d('Cancel click')">Cancel</button>
        <button type="button" class="btn btn-orange" [disabled]="bulkActionSubmitting" (click)="submitBulkAction(c)">
            {{ bulkActionSubmitting ? 'Submitting...' : 'Submit for Approval' }}
        </button>
    </div>
</ng-template>

<ng-template #panelHistoryModal let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">History — {{ historyPanel?.sr_no }}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Close click')"></button>
    </div>
    <div class="modal-body">
        <div class="activity-item" *ngFor="let activity of historyPanel?.activities">
            <div class="activity-head">
                <strong>{{ activity.created_by?.first_name || 'System' }}</strong>
                <small class="text-muted">{{ activity.created_at | date: 'medium' }}</small>
            </div>
            <div class="activity-status" *ngIf="activity.new_status">
                <span class="badge badge-custom badge-sm" *ngIf="activity.old_status_display"
                    [ngClass]="getPanelStatusBadgeClass(activity.old_status)">{{ activity.old_status_display }}</span>
                <i class="fa fa-arrow-right activity-arrow" *ngIf="activity.old_status_display"></i>
                <span class="badge badge-custom badge-sm" [ngClass]="getPanelStatusBadgeClass(activity.new_status)">{{ activity.new_status_display }}</span>
            </div>
            <p class="activity-message text-pre-wrap mb-0" *ngIf="activity.message">{{ activity.message }}</p>
        </div>
        <p class="text-muted text-center py-3" *ngIf="!historyPanel?.activities?.length">No activity yet.</p>
    </div>
</ng-template>

<ng-template #costUpdate let-c="close" let-d="dismiss">
    <form (ngSubmit)="updateInstallationCost()">
        <div class="modal-header">
            <h4 class="modal-title">Installation Cost Update</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="handleCancel(d)">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.633" height="14.25" viewBox="1222.583 108.567 13.633 14.25">
                    <path d="m1224 110 5.393 5.393 5.393-5.393" stroke-linejoin="round" stroke-linecap="round"
                        stroke-width="2" stroke="#fff" fill="transparent" />
                    <path d="m1224 121.393 5.393-5.393 5.392 5.393" stroke-linejoin="round" stroke-linecap="round"
                        stroke-width="2" stroke="#fff" fill="transparent" />
                </svg>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 form-styles">
                    <label for="updateCost">Update Installation Cost:</label>
                    <input id="updateCost" type="text" class="form-control" placeholder="0.0"
                        [(ngModel)]="plantDetail.cost" name="updateCost" appNumberInput />
                </div>
            </div>
        </div>
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" (click)="handleCancel(d)">Cancel</button>
            <button type="submit" class="btn btn-orange" (click)="c('Save click')">Save</button>
        </div>
    </form>
</ng-template>

<ng-template #calculatePredictionParameter let-c="close" let-d="dismiss">
    <form [formGroup]="predictionParameterForm" (ngSubmit)="onPredictionParamters()">
        <div class="modal-header">
            <h4 class="modal-title">Prediction Parameters</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="handleCancel(d)">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.633" height="14.25" viewBox="1222.583 108.567 13.633 14.25">
                    <path d="m1224 110 5.393 5.393 5.393-5.393" stroke-linejoin="round" stroke-linecap="round"
                        stroke-width="2" stroke="#fff" fill="transparent" />
                    <path d="m1224 121.393 5.393-5.393 5.392 5.393" stroke-linejoin="round" stroke-linecap="round"
                        stroke-width="2" stroke="#fff" fill="transparent" />
                </svg>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 form-styles mb-3">
                    <label for="cost">Installation Cost:</label>
                    <input id="cost" type="text" class="form-control" formControlName="cost" readonly />
                </div>
                <div class="col-md-12 form-styles mb-3">
                    <label for="baseProduction">Estimated Production First Year(Units)</label>
                    <input id="baseProduction" type="text" class="form-control" formControlName="baseProduction"
                        [value]="predictionParameterForm.get('baseProduction')?.value | number:'2.0-0'" appNumberInput />
                    <div *ngIf="predictionParameterForm.get('baseProduction').invalid && predictionParameterForm.get('baseProduction').touched"
                        class="text-danger">Estimated Production is required.</div>
                </div>
                <div class="col-md-12 form-styles mb-3">
                    <label for="nextYearProduction">Estimated Production Second Year(Units)</label>
                    <input id="nextYearProduction" type="text" class="form-control" formControlName="nextYearProduction"
                        [value]="predictionParameterForm.get('nextYearProduction')?.value | number:'2.0-0'"
                        appNumberInput />
                    <div *ngIf="predictionParameterForm.get('nextYearProduction').invalid && predictionParameterForm.get('nextYearProduction').touched"
                        class="text-danger">Estimated Production is required.</div>
                </div>
                <div class="col-md-12 form-styles mb-3">
                    <label for="tariffRate">Tariff Rate</label>
                    <input id="tariffRate" type="text" class="form-control" formControlName="tariffRate" maxlength="5"
                        appNumberInput />
                    <div *ngIf="predictionParameterForm.get('tariffRate').invalid && predictionParameterForm.get('tariffRate').touched"
                        class="text-danger">Please enter a valid number with up to 2 decimal places.</div>
                </div>
                <div class="col-md-12 form-styles mb-3">
                    <label for="dipPercentage">Decline / Year (%)</label>
                    <input id="dipPercentage" type="text" class="form-control" formControlName="dipPercentage"
                        maxlength="4" appNumberInput />
                    <div *ngIf="predictionParameterForm.get('dipPercentage').invalid && predictionParameterForm.get('dipPercentage').touched"
                        class="text-danger">Please enter a valid number with up to 2 decimal places.</div>
                </div>
            </div>
        </div>
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" (click)="handleCancel(d)">Cancel</button>
            <button type="submit" class="btn btn-orange" (click)="c('Save click')"
                [disabled]="predictionParameterForm.invalid">Save</button>
        </div>
    </form>
</ng-template>
